import { render, staticRenderFns } from "./Profile-Email-Update.vue?vue&type=template&id=d827bf08&scoped=true&"
import script from "./Profile-Email-Update.vue?vue&type=script&lang=js&"
export * from "./Profile-Email-Update.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Email-Update.vue?vue&type=style&index=0&id=d827bf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827bf08",
  null
  
)

export default component.exports